import commonConst from "../constants/commonConst";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("global");

export default {
  methods: {
    ...mapActions(["updateCartNumber"]),
    addToCart: async function() {
      const quantity = this.quantity || 1;
      // check positive number
      if (
        !quantity ||
        /^([0-9]*)$/.test(quantity) === false ||
        quantity === "0"
      ) {
        this.$swal.fire({
          title: "バリデーションに失敗しました:",
          text: "正数は入力ください。",
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: commonConst.CONFIRM_BUTTON_COLOR,
        });
        return;
      }
      // TODO: add to cart API
      try {
        const res = await this.$axios.post("/carts/add.json", {
          product_id: this.product.id,
          quantity: parseInt(quantity, 10),
        });

        const order = res.data;

        this.$root.$refs.addToCartModal.open({
          product: this.product,
          quantity: quantity,
          order: order,
        });

        this.updateCartNumber(order.number_of_order_items);
      } catch (e) {
        this.$swal.fire({
          title: "エラー発生しました。",
          text: e.response.data,
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: commonConst.CONFIRM_BUTTON_COLOR,
        });
      }
    },
  },
};
